'use client';
import React, { useState, useEffect } from 'react';
import { siteConfig, getOpenStatus } from '../../config/site';
import { PhoneIcon } from '@heroicons/react/24/outline';

export default function AnnouncementBar() {
  const [status, setStatus] = useState({ isOpen: false, statusText: 'Loading...', nextChange: '' });

  useEffect(() => {
    setStatus(getOpenStatus());
    const interval = setInterval(() => setStatus(getOpenStatus()), 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full text-xs font-medium" style={{ backgroundColor: 'var(--surface)', borderBottom: '1px solid var(--border-color)' }}>
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <span
            className="inline-block w-2 h-2 rounded-full flex-shrink-0"
            style={{
              backgroundColor: status.isOpen ? 'var(--brand)' : '#ef4444',
              boxShadow: status.isOpen ? '0 0 6px var(--brand)' : '0 0 6px #ef4444',
            }}
          />
          <span style={{ color: status.isOpen ? 'var(--brand)' : 'var(--text-muted)' }}>
            {status.statusText}
          </span>
        </div>
        <a
          href={siteConfig.phone.tel}
          className="flex items-center gap-1.5 font-semibold transition-opacity hover:opacity-80"
          style={{ color: 'var(--brand)' }}
          onClick={() => {
            if (typeof window !== 'undefined' && (window as unknown as { gtag?: Function }).gtag) {
              (window as unknown as { gtag: Function }).gtag('event', 'call_click', { location: 'announcement_bar' });
            }
          }}
        >
          <PhoneIcon className="w-3.5 h-3.5" />
          {siteConfig.phone.display}
        </a>
      </div>
    </div>
  );
}